import React from 'react';

interface EmailIconProps {
  size?: number;
  color?: string;
}

export const EmailIcon: React.FC<EmailIconProps> = ({ 
  size = 16, 
  color = '#6e6e6e' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 16 16"
    >
      <path 
        fill={color} 
        d="M14.666 4c0-.733-.6-1.333-1.333-1.333H2.666c-.733 0-1.333.6-1.333 1.333v8c0 .733.6 1.333 1.333 1.333h10.667c.733 0 1.333-.6 1.333-1.333zm-1.333 0L8 7.327 2.666 4zm0 8H2.666V5.333L8 8.666l5.333-3.333z"
      />
    </svg>
  );
};

